<template>
  <v-text-field v-bind="{ ...$attrs, ...commonAttrs }" v-on="$listeners">
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'Textfield',
  inheritAttrs: false,
  computed: {
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
      }
    }
  }
};
</script>
<style lang="css" scoped>
/deep/.v-input__prepend-inner{
  padding-left: 4px;
}
</style>
<style lang="scss" scoped>
.v-text-field::v-deep {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.v-input__slot::v-deep {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>